import styled from 'styled-components'
import { Col } from 'react-styled-flexboxgrid-tmp'

export const _BuildingPreviewCol = styled(Col)`
  width: 20%;
  padding: 0 8px;
  margin-bottom: 16px;
  position: relative;
  > a {
    display: block;
    max-width: 100%;
    overflow: hidden;
  }
  @media screen and (max-width: 1900px) {
    width: 25%;
  }

  @media screen and (max-width: 1550px) {
    width: 33.3%;
  }

  @media screen and (max-width: 1250px) {
    width: 50%;
  }

  @media screen and (max-width: 580px) {
    width: 100%;
  }

`
